import React from "react";
import { Link } from "react-router-dom";
import { Mail, MessageCircle, Globe } from "lucide-react";
import { NAV_LINKS, SERVICES, WHATSAPP_NUMBER, WHATSAPP_DISPLAY, EMAIL } from "@/data/content";

export function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#090B0E]" data-testid="main-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <img src="/imperium-logo.jpg" alt="Imperium Group logo" className="h-11 w-11 rounded-lg object-cover ring-1 ring-[#FF4500]/40" />
              <span className="font-display text-lg font-bold text-white">Imperium<span className="text-[#FF4500]"> Group</span></span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">Full-service marketingbureau. Van digitale marketing tot telemarketing — wij bieden echt álles op het gebied van marketing.</p>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-[#FF4500]">Navigatie</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (<li key={l.to}><Link to={l.to} className="text-sm text-slate-400 transition-colors hover:text-white">{l.label}</Link></li>))}
              <li><Link to="/offerte" className="text-sm text-slate-400 transition-colors hover:text-white">Offerte aanvragen</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-[#FF4500]">Diensten</h4>
            <ul className="mt-5 space-y-3">
              {SERVICES.slice(0, 6).map((s) => (<li key={s.slug}><Link to="/diensten" className="text-sm text-slate-400 transition-colors hover:text-white">{s.title}</Link></li>))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-[#FF4500]">Contact</h4>
            <ul className="mt-5 space-y-4 text-sm text-slate-400">
              <li className="flex items-start gap-3"><MessageCircle className="mt-0.5 h-4 w-4 text-[#FF4500]" /><a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" className="hover:text-white">{WHATSAPP_DISPLAY}</a></li>
              <li className="flex items-start gap-3"><Mail className="mt-0.5 h-4 w-4 text-[#FF4500]" /><a href={`mailto:${EMAIL}`} className="hover:text-white">{EMAIL}</a></li>
              <li className="flex items-start gap-3"><Globe className="mt-0.5 h-4 w-4 text-[#FF4500]" /><span>www.imperiumgroup.nl</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 md:flex-row">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Imperium Group — Full-Service Marketingbureau.</p>
          <p className="text-xs text-slate-500">Digitaal · Telemarketing · TV · Radio · OOH · Nederland</p>
        </div>
      </div>
    </footer>
  );
}
